
(function () {
  /* RÉTABLISSEMENT DU BOUTON « VOIR PLUS » — NE PAS RETIRER
     ------------------------------------------------------------------
     Le thème décide de l'afficher avec
         bodyEl.scrollHeight <= bodyEl.clientHeight + 4
     ce qui est TOUJOURS vrai parce que .nty-desc__body est en overflow:clip
     (pas de région de débordement défilable, donc scrollHeight == clientHeight).

     On ne touche PAS à overflow : c'est un correctif de défilement délibéré du
     thème, le modifier risquerait de réintroduire le bug qu'il corrige.
     On mesure autrement : on libère TEMPORAIREMENT la contrainte de hauteur en
     style inline important (seul moyen de battre un !important de feuille de
     style), on lit la hauteur réelle du contenu, puis on retire immédiatement
     les propriétés inline. La mesure est synchrone : rien n'est peint entre les
     deux, aucun scintillement possible.

     Le bloc 4 étant inactif, la troncature est de nouveau effective sur les
     deux tailles d'écran : ce JS est donc bien ce qui fait apparaître le bouton
     « Voir plus » dès que le texte déborde, et le masque quand il tient.

     CONTRAINTES RESPECTÉES :
       · aucune expression régulière ;
       · aucun MutationObserver, donc aucune surveillance d'attributs de style ;
       · le gestionnaire de clic du thème n'est ni remplacé ni redéfini : la
         bascule .is-open reste la sienne, on ne corrige que la VISIBILITÉ. */

  if (window.__almeaDescToggleFix) return;
  window.__almeaDescToggleFix = true;

  function measureFullHeight(body) {
    body.style.setProperty('max-height', 'none', 'important');
    body.style.setProperty('overflow', 'visible', 'important');
    body.style.setProperty('-webkit-mask-image', 'none', 'important');
    var full = body.scrollHeight;
    body.style.removeProperty('max-height');
    body.style.removeProperty('overflow');
    body.style.removeProperty('-webkit-mask-image');
    return full;
  }

  function refreshToggle() {
    var section = document.getElementById('mz-product-description');
    if (!section) return;

    var clamp = section.querySelector('.nty-desc__clamp');
    var body = section.querySelector('.nty-desc__body');
    var tg = section.querySelector('.nty-desc__toggle');
    if (!clamp || !body || !tg) return;

    if (clamp.classList.contains('is-open')) {
      tg.classList.remove('almea-desc-fits');
      tg.style.removeProperty('display');
      return;
    }

    var limited = body.clientHeight;
    var full = measureFullHeight(body);

    if (full > limited + 4) {
      tg.classList.remove('almea-desc-fits');
      tg.style.removeProperty('display');
    } else {
      tg.classList.add('almea-desc-fits');
    }
  }

  refreshToggle();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshToggle);
  }
  window.addEventListener('load', refreshToggle);

  var delays = [150, 400, 1000, 2200, 4000];
  for (var i = 0; i < delays.length; i++) { setTimeout(refreshToggle, delays[i]); }

  try {
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(refreshToggle);
    }
  } catch (e) {}

  var rzTimer = null;
  window.addEventListener('resize', function () {
    if (rzTimer) clearTimeout(rzTimer);
    rzTimer = setTimeout(refreshToggle, 150);
  });

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.classList) return;
    if (t.classList.contains('nty-desc__toggle')) { setTimeout(refreshToggle, 30); }
  }, true);
})();
